module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-prev-circle-53f29efa19fd48275ef9a10925872098.svg";